export enum UiTypes {
  none = 'none',
  account = 'account',
  transaction = 'transaction',
  asset = 'asset',
  token = 'token',
  block = 'block',
  chain = 'chain',
  meta = 'meta',
}